import get from 'lodash/get';

const Api = {
  baseUrl: process.env.VUE_APP_API_URL,

  hostname: null,

  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-locale': null,
  },

  init() {
    this.hostname = get(window.centralAdminOrderForm, 'config.hostname', window.location.hostname);
  },

  setLocale(locale) {
    this.headers['x-locale'] = locale;
  },

  handleErrors: response => {
    if (!response.ok && response.status !== 404) {
      throw Error(response.statusText);
    }
    return response;
  },

  post(path, data) {
    data.hostname = this.hostname;
    data.order_form_url = window.location.protocol + '//' + window.location.hostname + window.location.pathname;

    return fetch(`${this.baseUrl}/${path}`, {method: 'post', body: JSON.stringify(data), headers: this.headers, mode: 'cors'})
      .then(this.handleErrors)
      .then(response => response.json())
      .catch(error => {
        console.log(error);
        alert('Error has occurred, please try again');
        throw error;
      });
  },

  get(path, params = {}) {
    params.hostname = this.hostname;

    const query = Object.keys(params)
      .map(key => `${key}=${window.encodeURIComponent(params[key])}`)
      .join('&');

    return fetch(`${this.baseUrl}/${path}?` + query, {method: 'get', headers: this.headers, mode: 'cors'})
      .then(this.handleErrors)
      .then(response => {
        return response.json().then(data => ({data, status: response.status}))
      })
      .catch(error => {
        console.error(error);
        alert('Error has occurred, please try again');
        throw error;
      });
  },

  order(data) {
    return Api.post('order', data);
  },

  getWebsiteProducts() {
    return Api.get('products');
  },

  discountCode(code) {
    return Api.get('discounts', {code});
  },
}

export default Api;
